import { render, staticRenderFns } from "./ExamineQuestionnaire.vue?vue&type=template&id=f12cf11e&scoped=true"
import script from "./ExamineQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./ExamineQuestionnaire.vue?vue&type=script&lang=ts"
import style0 from "./ExamineQuestionnaire.vue?vue&type=style&index=0&id=f12cf11e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12cf11e",
  null
  
)

export default component.exports